<script>
import { useNavigate, useLocation } from "svelte-navigator";
import { user } from "./store";

const navigate = useNavigate();
const location = useLocation();

// Move to app
$: $location, window.scrollTo(0, 0)

$: if (!$user) {
  navigate("/signin", {
    state: { from: $location.pathname },
    replace: true,
  });
}
</script>

{#if $user}
  <!-- Pass location to be useful -->
  <slot {location} />
{/if}